define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/keys",
	"dojo/on",
	"dojo/topic",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/locale",
	"csi/xml"
], function(declare,lang,keys,on,topic,_,Controller,locale,xml) {

	return declare(Controller, {
		// Boolean: hold all changes until pause in editing
		bHold: true,

		// Boolean: action can be interrupted at any time
		bModal: false,

		// Number: counts the number of moves down (negative if up)
		nDiff: 0,

		// DOMNode: next refNode in move direction
		//targetNode: null,

		// Object: handle for keypress events
		//_handleKeyPress: null,

		// Object: timer handle for action
		//_timeout: null,

		constructor: function(/*Object*/params) {
			var	self = this;

			this.m_bUp = this.m_action.bUp;
			this.m_urlParentTarget = this.m_urlParent;
			this.m_idAttrParentTarget = this.m_idAttrParent;

			// only allow keyboard input if in view and not on toolbar
			if (!this.m_action.bActOnSelections) {
				this._handleKeyPress = on(document, "keydown", function(e) {
					// summary: if up/down key, then restart action
					var	bUp = (e.keyCode == keys.UP_ARROW);
					var	bDown = (e.keyCode == keys.DOWN_ARROW);

					if (bUp || bDown) {
						e.stopPropagation();
						e.preventDefault();

						self.m_bUp = bUp;
						self.preProcess();
					}
				});
			}
		},

		interruptProcess: function() {
			// summary: if action interrupted by another, then start processing now
			if (this._timeout) {
				clearTimeout(this._timeout);
				this._timeout = null;
				this.process();
			} else {
				this.inherited(arguments);
			}
		},

		preProcess: function() {
			// summary: highlight node being moved and process
			if (this.refNode) {
				this.widget.highlight(this.refNode, false, true);

				if (this.targetNode = this.widget.getRefNodeNext(this.refNode, this.m_bUp, true)) {
					this.nDiff += this.m_bUp ? -1 : 1;
				}
			}

			//set disabled to false to enable up down arrows even when a row is highlighted
			this.disableActionView(false);

			// if allowing keyboard input, then wait for it (up to 2 seconds)
			if (this._handleKeyPress) {
				if (this._timeout) {
					clearTimeout(this._timeout);
				}

				this._timeout = setTimeout(lang.hitch(this, this.process), 2000);
			} else {
				this.process();
			}
		},

		process: function() {
			// summary: unhighlight block
			if (this.refNode) {
				this.widget.highlight(this.refNode, true, true);
			}

			this.inherited(arguments);
		},

		toWriter: function() {
			// if no parent at all, then this is just a UI action
			var	call;

			if (!this.m_urlParent || !this.nDiff) {
				return null;
			}

			if (this.m_urlParent == this.m_urlParentTarget) {
				// if under the same parent, then remove source and add next to dest in the same array
				var value = this.getParentAttributeValue();
				var nStart = _.indexOf(value, this.m_urlNode);
				
				// find end index based on next row's index in vector (similar to code in DndOrderedController)
				var view = this.widget;
				var refNodeNext = view.getRefNodeNext(this.refNode);
				var qrNext = refNodeNext ? view.getQueryResultByDomNode(refNodeNext) : null;
				var urlBefore = qrNext ? qrNext.getResultUrl() : null;
				var nEnd = urlBefore ? _.indexOf(value, urlBefore) : value.length;

				// if moving a row down in list, then it needs to act like you are first removing the row, and then inserting it back;
				// when the row is removed, the end index needs to decrease by one. In the DnD case, we actually do remove the row first
				// before inserting, so simulate that here too
				if (nStart < nEnd) {
					--nEnd;
				}
				
				if (call = this.inherited(arguments)) {
					call.addParameter(xml.PROP_INDEX_FROM, xml.ATTR_INTEGER, nStart);
					call.addParameter(xml.PROP_INDEX_TO, xml.ATTR_INTEGER, nEnd);
				} else {
					this.m_writer.changeNode(this.m_urlParent).moveAttributeKey(this.m_idAttrParent, this.getParentAttributeType(), nStart, nEnd);
				}
			} else {
				// FIX: handle different parents
			}

			return call;
		},

		postProcess: function(/*Boolean*/bStatus) {
			// summary: clean up event handles
			if (this._handleKeyPress) {
				this._handleKeyPress.remove();
			}

			this.inherited(arguments);
		}
	});
});